import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import {VerticalDivider, VerticalReading, VerticalDateTime} from '../../../../shared/components'
import CardUserInfo from './CardUserInfo'
import {LuClock4} from 'react-icons/lu'
import axios from 'axios'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {Link} from 'react-router-dom'

export interface PatientCardProps {
  name?: string
  phone?: string
  systolic?: string
  diastolic?: string
  bpm?: string
  datetime?: string
  isReading?: boolean
  message?: string
  patientUUID: string
  readingId?: number
  onResolved: (readingId: number) => void
}

const PatientCard: React.FC<PatientCardProps> = ({
  name = '',
  phone = '',
  systolic = '',
  diastolic = '',
  bpm = '',
  datetime = '',
  isReading = true,
  message = '',
  patientUUID,
  readingId,
  onResolved,
}) => {
  // accept the click event so we can stop it
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleResolveClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (readingId == null) return

    try {
      await axios.put(
        API_ENDPOINTS.UPDATE_READING_ALERT(patientUUID, readingId),
        {},
        {params: {reading_id: readingId}}
      )
      onResolved(readingId)
    } catch (err) {}
  }

  return (
    <Link to={`/patient-details/${patientUUID}`} className='custom-card-wrapper'>
      <div className='custom-card me-3 p-3'>
        {/* header: centered user info + tick */}
        <div className='d-flex mb-2'>
          <CardUserInfo name={name} phone={phone} />
          {/* {isReading && (
            <button
              className='btn p-0 ms-4'
              onClick={handleResolveClick}
              title='Mark as resolved'
              style={{background: 'none', border: 'none'}}
            >
              <FaCheckCircle size={20} />
            </button>
          )} */}
        </div>

        {isReading ? (
          <div className='d-flex align-items-center justify-content-between'>
            <VerticalReading topValue={systolic} bottomValue={diastolic} bpmValue={bpm} />
            <VerticalDivider />
            <VerticalDateTime datetime={datetime} />
          </div>
        ) : (
          <div className='d-flex align-items-center gap-2'>
            <div className='text-muted mt-3'>
              <LuClock4 size={26} />
              <span className='fs-6 ms-2'>{message}</span>
            </div>
          </div>
        )}
      </div>
    </Link>
  )
}

export default PatientCard
